const AccountActionTypes = {
  FETCH_ACCOUNT_START: "FETCH_ACCOUNT_START",
  FETCH_ACCOUNT_SUCCESS: "FETCH_ACCOUNT_SUCCESS",
  FETCH_ACCOUNT_FAILURE: "FETCH_ACCOUNT_FAILURE",
  UPDATE_ACCOUNTS: "UPDATE_ACCOUNTS",
  RESET_TO_INITIAL_STATE: "RESET_TO_INITIAL_STATE",
}

export default AccountActionTypes
